import ZoomifyJs from "zoomifyjs";

var calcPriceProduct = function (productSize) {
    let $offerRow    = productSize.find('.offer-wr');
    let $totalBlock  = productSize.find('.total-block');
    let $btnCart     = $totalBlock.find('.btn.add-to-cart');
    let $userPrice   = productSize.find('.my-price .price');

    var totalPrice = 0;
    var totalCount = 0;

    $offerRow.each(function (index, element) {
        var _this = $(this);

        if (CW.isOpt || CW.isPersonal || CW.isSale || _this.data('rozn') > CW.OPT_BORDER) {
            const coeffPrice = CW.coeffPrice ? CW.coeffPrice : 1;
            var price = Number(_this.data('opt')) * coeffPrice;
        } else {
            var price = Number(_this.data('rozn'));
        }

        var id = Number(_this.data('id'));
        var input = _this.find('.amount-input');

        if (input.prop('disabled')) {
            return;
        }

        var count = Number(input.val());
        totalPrice += price * count;

        if (count > 0) {
            totalCount++;
            $btnCart.removeClass('btn-default');
        }
    });

    $totalBlock.find('.sum').text(CW.price(totalPrice, true));

    if (totalCount == 0) {
        $btnCart.addClass('btn-default');
    }else{
        $btnCart.removeClass('btn-default');
    }
};

var calcPreorderProduct = function (productSize){
    if(!productSize.hasClass('pre-order-table')){
        return false;
    }
    let $offerRow    = productSize.find('.offer-wr');
    let $totalBlock  = productSize.find('.total-block');


    var totalPrice = 0;
    var totalCount = 0;

    $offerRow.each(function (index, element) {
        var _this = $(this);

        var price = Number(_this.data('price'));
        var input = _this.find('.amount-input');

        var count = Number(input.val());
        if (!isNaN(price)) {
           totalPrice += price * count;
        }
    });

    $totalBlock.find('.pre-order-sum').text(CW.price(totalPrice, true));
};

//функция для обработки нажатия на кнопки изменения кол-ва товара (для товара с торговыми предложениями)
function changeQuantityHandle() {
    let $$productSize = $(this).closest('.product-size-block');
    let $amountSelector = $(this).closest('.amount-selector');
    let $offerWr =  $(this).closest('.offer-wr');
    let $input =  $amountSelector.children('.amount-input');
    let inputVal = Number($input.val());

    let multy = 1;

    if($offerWr.length > 0){
        multy = $offerWr.data('multy') ? Number($offerWr.data('multy')) : 1;
    }

    // если товар - товар вида b2c с выбором размера (торг предложениями)
    if($(this).closest('.b2c-actions-row').length > 0) {
        multy = $(this).closest('.b2c-actions-row').data('multy') ? Number($(this).closest('.b2c-actions-row').data('multy')) : 1;
    }

    let minOrderQuantity = 0;
    let maxOrderQuantity = 0;

    if($input.attr('min') !== undefined)
        minOrderQuantity = parseInt($input.attr('min'));
    if($input.attr('max') !== undefined)
        maxOrderQuantity = parseInt($input.attr('max'));

    if ($(this).hasClass('plus')) {
        $input.val(inputVal + multy);
    } else {
        if (inputVal > 0) {
            $input.val(inputVal - multy);
        }
    }

    if(maxOrderQuantity === 0 && $input.hasClass('OBOSOBLENNOE_OBESPECHENIE'))
        $input.val(0);

    if(parseInt($input.val()) < minOrderQuantity && minOrderQuantity > 0 && $(this).hasClass('minus'))
        $input.val(0);

    if(parseInt($input.val()) < minOrderQuantity && minOrderQuantity > 0 && $(this).hasClass('plus'))
        $input.val(minOrderQuantity);

    if(parseInt($input.val()) > maxOrderQuantity && maxOrderQuantity > 0) {
         $input.val(maxOrderQuantity);
    }

    calcPriceProduct($$productSize);
    calcPreorderProduct($$productSize);
}


$(function () {
    //добавить в избранное
    $('.product-page .add-to-favorites').on('click', function () {
        var _this = $(this);
        var productId = _this.data("product-id");
        var action = 'add';

        if(_this.hasClass('in-favorites')){
            action = 'remove';
        }
        $.ajax({
            url: '/ajax/favorites/',
            global: false,
            type: "POST",
            data: ({
                action: action,
                id: productId
            }),
            success: function (res) {
                if(res.result && res.result == 'fail'){
                    console.log(res.error);
                }else{
                    CW.basket.setBasket(res);
                }
            },
            error: function(xhr, status, error) {
                console.error('Favorites error:', status, error);
                throw new Error('Favorites error: ' + status + ' - ' + error);
            }
        });
    });

    //добавит в корзину - перенести все размеры в инпут "Показать размер"
    $('.product-page .product-size-block .btn.add-to-cart').on('click', function () {
        let btnSelectSize = $('.product-page .info-product-wr .btn-select-size input');
        let bntCart = $('.product-page .info-product-wr .btn');
        let productSizeBlock = $(this).closest('.product-size-block');
        let $tableSize = productSizeBlock.find('.tab-content-wr .size-table');
        let $offerRow = $tableSize.find('.offer-wr');
        let allSelectSize = '';
        let flag = false;

        $offerRow.each(function (index) {
            let $this = $(this);
            let $inputSize = $this.find('.amount-input');
            let nameSize = $this.children('.size-value').text(); // empty string

            if ($inputSize.val() > 0) {
                flag = true;
                allSelectSize += nameSize + ', ';
            }

            if ($inputSize.prop('disabled')) {
                return;
            }

            var id = Number($this.data('id')); // id строчки оффера (строчки с конкретным размером)
            var count = Number($inputSize.val()); // сколько единиц этого размера

            if (count > 0) {
                CW.Cart.push({id: id, quantity: count});
                // $inputSize.prop('disabled', true);
            }
        });

        if (flag) {
            btnSelectSize.val(allSelectSize.slice(0, -2));
            bntCart.addClass('red-btn');
            // if(!bntCart.hasClass('btn-select-size'))
            //     bntCart.addClass('in-basket');
        }


        // для товара вида b2c
        let productSizeBlockB2c = $(this).closest('.product-size-block.product-size-block--b2c');
        let $offerRowB2c = productSizeBlockB2c.find('.offer-wr');
        let $selectedOfferRow = productSizeBlockB2c.find('.offer-wr--selected');

        if($selectedOfferRow.length) {
            let $productInputSize = productSizeBlockB2c.find('.amount-input');
            const count = Number($productInputSize.val()); // сколько единиц этого размера
            const id = Number($selectedOfferRow.data('id')); // id строчки оффера (строчки с конкретным размером)
            if (count > 0) {
                CW.Cart.push({id: id, quantity: count});
            }
        }

        // добавление в корзину
        if (CW.Cart.length > 0) {
            CW.basket.syncBasket(CW.Cart);
            CW.Cart = [];
            calcPriceProduct(productSizeBlock);  // запускаем перекалькулирвание
        } else {
            alert('Выберите товар!');
        }
    });

    //показать все фотографии
    $(document).ready(function () {
        let lengthElem = $('.product-row .photo-nav .nav-item').length;
        let lengthSlide = $('.product-row .slider-nav .slick-slide').length;

        // if (lengthElem > 6) {
        //     $('.product-row .slider-nav').before('<a class="photo-nav-link all-photo nav-item"><span class="title-h2">' + lengthSlide + '</span> фото</a>')
        // }
    });

    //слайдер для больших фотографий товаров
    $('.product-page .slider-big-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        prevArrow: '<div class="arrow-slider a-prev"><svg width="12" height="12"><use xlink:href="/src/img/svg-sprite.svg#icon-arrow"></use></svg></div>',
        nextArrow: '<div class="arrow-slider a-next"><svg width="12" height="12"><use xlink:href="/src/img/svg-sprite.svg#icon-arrow"></use></svg></div>',
        fade: false,
        infinite: true,
        asNavFor: '.product-page .slider-nav',
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 1345,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                },
            },
        ]
    });

    //слайдер для мини-фото товаров
    if($('.product-page .slider-big-img .big-img').length > 1) {
        //слайдер для мини-фото товаров
        $('.product-page .slider-nav').slick({
            slidesToScroll: 1,
            slidesToShow: 5,
            asNavFor: '.product-page .slider-big-img',
            focusOnSelect: true,
            accessibility: true,
            arrows: true,
            prevArrow: '<div class="arrow-slider a-prev"><svg width="12" height="12"><use xlink:href="/src/img/svg-sprite.svg#icon-arrow"></use></svg></div>',
            nextArrow: '<div class="arrow-slider a-next"><svg width="12" height="12"><use xlink:href="/src/img/svg-sprite.svg#icon-arrow"></use></svg></div>',
            vertical: false,
            /*
            responsive: [
                {
                    breakpoint: 1344,
                    settings: {
                        arrows: false,
                    }
                }

             */
        });
    } else {
        $('.product-page .slider-nav').css('display', 'none')
    }
    // если в слайдере меньше 5 фотографий - убираем паддинги у слайдера навигации
    if($('.product-page .slick-slide:not(.slick-cloned) .big-img').length < 5) {
        $('.product-page .slider-nav').css('padding', '0')
    }

    //слайдер для адаптива в табах
    $('.product-page .carousel__inner').slick({
        speed: 1200,
        slidesToShow: 2,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
    // //инициализируем fancybox
    $('.fancybox').fancybox({
        buttons: ["close", "zoom",],
        infobar: false,
        animationEffect: false,
        arrows: true,
        backFocus: false,
        hash: false,
        zoom: true,
        clickContent: function (current, event) {
            return current.type === "image" ? "zoom" : false;
        },
        Image: {
            wheel: "zoom",
        },
    });

    //открыть видео
    $('.fancybox-media').fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        helpers: {
            media: {}
        }
    });

    //открыть 3d модель
    $('.product-row .photo-nav .photo-nav-link.model-3d').on('click', function () {
        let $parent = $(this).closest('.product-photo-wr');

        $parent.children('.photo-360-wr').addClass('show');
    });

    //открыть все фото
    $('.product-row .photo-nav').on('click', '.photo-nav-link.all-photo', function () {
        let $parent = $(this).closest('.product-photo-wr');

        $parent.find('.slick-slide.slick-current .big-img').find('.fancybox:first').trigger('click');
        return false;
    });

    //при ховере на образце расцветки товара подставляем название цвета

    // Сохраняем исходное значение до первого наведения
    saveInitialColorTitle();

    function saveInitialColorTitle() {
        if (!$('.product-color-variants__title').attr('initial-title')) {
            $('.product-color-variants__title').attr('initial-title', $('.js-color-variant-title').text());
        }
    }

    function setInitialTitle() {
        const titleElem = $('.js-color-variant-title');
        const initialText = $('.product-color-variants__title').attr('initial-title');
        titleElem.text(initialText);
    }

    $('.color-variant-item').hover(
        function() {
            const title = $(this).find('a').data('title');
            $('.js-color-variant-title').text(title);
        },
    );

    $('.product-color-variants__wrapper').mouseleave(setInitialTitle);

    //открыть слайды
    $('.product-row .slider-nav .nav-img').on('click', function () {
        let $parent = $(this).closest('.product-photo-wr');

        $parent.children('.photo-360-wr').removeClass('show');
    });

    //zoom на изображении товара при наведении
    const zoomifyImages = document.querySelectorAll('.zoomifyJs');
    
    if (zoomifyImages.length && window.innerWidth > 768) { // Инициализация только если ширина экрана больше 768px
        zoomifyImages.forEach(img => {
            new ZoomifyJs({
                selector: img,
                transitionDuration: 350,
                easing: 'linear',
            });
        })
    }

    //открыть таблицу размеров по клику на кнопку Выбрать размер
    // + запустить перерасчет всего
    $('.product-row .btn-select-size').on('click', function () {
        let $sizeTable = $('.product-page .product-size-block.in-stock-table');
        const tableRows = $sizeTable.find('.offer-wr');

        tableRows.each(function (index, element) {
            let $this = $(this);
            const $tableRow = $($this);
            const $amountInput = $tableRow.find('.amount-selector .amount-input');
            const inputValue = $amountInput.val();

            if(inputValue > 0) {
                $amountInput.attr('value', inputValue);
            }
        })

        if ($sizeTable.hasClass('open')) {
            $sizeTable.removeClass('open');
            $('body').removeClass('fixed-body');
            $('body').removeClass('prevent-scroll');
        } else {
            $sizeTable.addClass('open');
            $('body').addClass('prevent-scroll');

            // рассчитываем стоимость выбранных товаров при открытии окна с размерами, рассчитается не 0, если какой то размер уже был выбран ранее

            let productSizeBlock = $sizeTable;
            calcPriceProduct(productSizeBlock);
        }

        if ($(window).width() <= 767 ) {
            $('body').toggleClass('fixed-body');
        }
    });

//открыть таблицу сообщить о наличии
    $('.product-page .report-availability').on('click', function () {
        $('.product-page .product-size-block.report').toggleClass('open');
        if ($(window).width() <= 767 ) {
            $('body').toggleClass('fixed-body');
        }
    });

//открыть таблицу размеров по клику на кнопку В корзину
    $('.product-row .product-action .btn').on('click', function (e) {
        var _this = $(this);

        var productId = _this.data("product-id");
        var isHaveOffers = _this.data("have-offers");

        if (!$(this).hasClass('in-basket')) {
            $('.product-page .product-size-block.in-stock-table').addClass('open');
            if ($(window).width() <= 767 ) {
                $('body').addClass('fixed-body');
            }

            if(isHaveOffers){
               $('.product-page .product-size-block.in-stock-table').addClass('open');
                if ($(window).width() <= 767 ) {
                    $('body').addClass('fixed-body');
                }
            }else{
                var amountInput = _this.closest('.product-action').find('.amount-input');
                var qnt = Number(amountInput.val());
                CW.basket.syncProduct(productId, qnt);
            }
        } else {
            document.location.href = "/basket/";
        }
    });

//закыть таблицу размеров
    $('.product-page .product-size-block .close-button').on('click', function () {
        let $parent = $(this).closest('.product-size-block');

        $parent.removeClass('open');
        $('body').removeClass('fixed-body');
        $('body').removeClass('prevent-scroll');
    });

    $('.product-page table.size-table .amount-input').change(
        function()
        {

            let minOrderQuantity = 0;
            let maxOrderQuantity = 0;

            if($(this).attr('min') !== undefined)
                minOrderQuantity = parseInt($(this).attr('min'));
            if($(this).attr('max') !== undefined)
                maxOrderQuantity = parseInt($(this).attr('max'));

            if(parseInt($(this).val()) < minOrderQuantity && minOrderQuantity > 0)
                $(this).val(minOrderQuantity);

            if(parseInt($(this).val()) > maxOrderQuantity && maxOrderQuantity > 0)
                $(this).val(maxOrderQuantity);

            if(maxOrderQuantity === 0 && $(this).hasClass('OBOSOBLENNOE_OBESPECHENIE'))
                $(this).val(0);
        }
    );

    //прослушивание изменений в инпуте для товаров с торг предложением
    $('.product-page .product-size-block .amount-selector').on('click', '.icon-mark', changeQuantityHandle);

    changeQuantityHandle()

    //разрешить только ввод цифр
    $('.product-page .amount-selector .amount-input').on('keydown', function (event) {

        if ( (event.key >= '0' && event.key <= '9') || event.key == 'Delete' || event.key == 'Backspace' || event.key == 'Enter') {
            return true;
        } else {
            event.preventDefault();
        }
    });

    //отправить данные по инпуту
    $('.product-page .product-size-block .amount-selector .amount-input').on('blur', function (e) {
        let $productSize = $(this).closest('.product-size-block');
        let $offerWr =  $(this).closest('.offer-wr');
        let inputVal = Number($(this).val());

        let multy = 1;

        multy = $offerWr.data('multy') ? Number($offerWr.data('multy')) : 1;
        let diff = inputVal % multy;

        if (diff) {
            $(this).val((inputVal - diff) + multy)
        }

        calcPriceProduct($productSize);
        calcPreorderProduct($productSize);
    });

    //ссылка на таб предзаказ
    $('.pre-order-link').on('click', function (e) {
        e.preventDefault();
        let $tabPreOrder = $('.product-page .pre-order-tab');

        $('html, body').animate({
            scrollTop: $tabPreOrder.offset().top - 100
        }, 500);

        $tabPreOrder.click();
    });

    //открыть таблицу размеров Пред-заказ
    $('.product-page .tabs-content .open-table-pre-order').on('click', function (e) {
        var _this = $(this);
        if(_this.closest('.wr-pre-order').hasClass('selected')){
            return false;
        }
        var number = _this.data('order');
        $('.product-page .product-size-block.pre-order-table').each(function (i, el) {
            $(el).removeClass('open');
        });
        $('.product-page .product-size-block.pre-order-number-' + number).toggleClass('open');
        if ($(window).width() <= 767 ) {
            $('body').toggleClass('fixed-body');
        }
    });

    //таблица размеров Пред-заказ - второй этап
    $('.product-page .product-size-block.pre-order-table .btn-second-step, .product-page .product-size-block.report .btn-second-step').on('click', function () {
        let $productSize = $(this).closest('.product-size-block');
        let $currentStep = $productSize.find('.second-step');

        $currentStep.addClass('opened');
    });

    //закыть таблицу размеров Пред-заказ по клику на Close
    $('.product-page .product-size-block.pre-order-table .close-button, .product-page .product-size-block.report .close-button').on('click', function () {
        let $parent = $(this).closest('.product-size-block');
        let $currentStep = $parent.find('.second-step');

        $parent.removeClass('open');
        $currentStep.removeClass('opened');
        $('body').removeClass('fixed-body');
        $('body').removeClass('prevent-scroll');
    });

    //отправить форму и закрыть таблицу
    $('.product-page .product-size-block.pre-order-table .btn-send-form').on('click', function () {
         $('.pre-order-form').trigger('click');
    });

    $('.product-page .product-size-block.report .btn-send-form').on('click', function () {
        $('.report-availability-form').trigger('click');
    });

    $('.pre-order-form ').on('submit', function (e) {
        var $form = $(this);
        var $parent = $form.find('.pre-order-table');
        var $currentStep = $parent.find('.second-step')

        e.preventDefault();
        $.ajax($form.attr('action'), {
            data: $form.serializeArray(),
            method: 'POST',
            success: function (data) {
                var a = JSON.parse(data);
                if (!a) {
                    return alert('Ошибка создания предзаказа');
                }
                if (a.error) {
                    alert("Ошибка: " + a.error);
                } else {
                    $parent.removeClass('open');
                    $currentStep.removeClass('opened');
                    $('.open-table-pre-order').each(function (i, el) {
                        if ($(el).data('order') == a.preorder) {
                            $(el).closest('.wr-pre-order').addClass('selected');
                        }
                    });
                }
            },
            error: function(xhr, status, error) {
                console.error('Pre-order form error:', status, error);
                throw new Error('Pre-order form error: ' + status + ' - ' + error);
            }
        });
    });

    $('.report-availability-form').on('submit', function (e) {
        var $form = $(this);
        var $parent = $form.find('.report');
        var $currentStep = $parent.find('.second-step')

        e.preventDefault();
        $.ajax($form.attr('action'), {
            data: $form.serializeArray(),
            method: 'POST',
            success: function (data) {
                if (data.result == 'fail') {
                    alert("Ошибка: " + data.error);
                } else{
                    $parent.removeClass('open');
                    $currentStep.removeClass('opened');
                }
            },
            error: function(xhr, status, error) {
                console.error('Report availability error:', status, error);
                throw new Error('Report availability error: ' + status + ' - ' + error);
            }
        });
    });

    //закрыть все таблицы по клику на экран

    /*
    $(document).mouseup(function (e) {
        var container = $(".product-size-block");
        if (container.has(e.target).length === 0){
            container.removeClass('open');
        }
    });

     */

    //функция для изменения кол-ва для товаров без торговых предложений
    function handleChangeQuantity() {
        let $amountSelector = $(this).closest('.amount-selector');
        let $input =  $amountSelector.children('.amount-input');
        let inputVal = Number($input.val());

        let minOrderQuantity = 0;
        let maxOrderQuantity = 0;

        if($input.attr('min') !== undefined)
            minOrderQuantity = parseInt($input.attr('min'));
        if($input.attr('max') !== undefined)
            maxOrderQuantity = parseInt($input.attr('max'));

        let multy = 1;
        multy = $amountSelector.data('multy') ? Number($amountSelector.data('multy')) : 1;

        if ($(this).hasClass('plus'))
        {
            $input.val(inputVal + multy);
        }
        else
        {
            if (inputVal > multy) {
                $input.val(inputVal - multy);
            } else {
                return;
            }
        }

        //если товар с обособленным обеспечением (не может быть заказано товара больше, чем имеется)
        if(maxOrderQuantity === 0 && $input.hasClass('OBOSOBLENNOE_OBESPECHENIE')) {
            $input.val(0);
        }

        if(parseInt($input.val()) < minOrderQuantity && minOrderQuantity > 0 && $(this).hasClass('minus'))
            $input.val(0);

        if(parseInt($input.val()) < minOrderQuantity && minOrderQuantity > 0 && $(this).hasClass('plus'))
            $input.val(minOrderQuantity);

        if(parseInt($input.val()) > maxOrderQuantity && maxOrderQuantity > 0) {
            $input.val(maxOrderQuantity);
        }
    }

    $('.product-page .product-action .choose-product').on('click', '.icon-mark',  handleChangeQuantity);

    //для товаров без товарных предложений - инпут
    //$('.product-page .product-action .amount-selector .amount-input').on('blur', handleChangeQuantity);

    //для товаров без товарных предложений - инпут
    $('.product-page .product-action .amount-selector .amount-input').on('blur', function (event) {
        let $input = $(this);
        let $productSize = $(this).closest('.product-size-block');
        let $amountSelector = $(this).closest('.amount-selector');
        let inputVal = Number($(this).val());
        let multy = 1;

        multy = $amountSelector.data('multy') ? Number($amountSelector.data('multy')) : 1;
        let diff = inputVal % multy;

        if (diff) {
            $(this).val((inputVal - diff) + multy)
        }

        if (inputVal <= 0) {
            $(this).val(multy);
        }

        let minOrderQuantity = 0;
        let maxOrderQuantity = 0;

        if($input.attr('min') !== undefined)
            minOrderQuantity = parseInt($input.attr('min'));
        if($input.attr('max') !== undefined)
            maxOrderQuantity = parseInt($input.attr('max'));

        //если товар с обособленным обеспечением (не может быть заказано товара больше, чем имеется)
        if(maxOrderQuantity === 0 && $input.hasClass('OBOSOBLENNOE_OBESPECHENIE')) {
            $input.val(0);
        }

        if(parseInt($input.val()) < minOrderQuantity && minOrderQuantity > 0 && $(this).hasClass('minus'))
            $input.val(0);

        if(parseInt($input.val()) < minOrderQuantity && minOrderQuantity > 0 && $(this).hasClass('plus'))
            $input.val(minOrderQuantity);

        if(parseInt($input.val()) > maxOrderQuantity && maxOrderQuantity > 0) {
            $input.val(maxOrderQuantity);
        }

        calcPriceProduct($productSize);
        calcPreorderProduct($productSize);
    });

    $('.add-size-product.js-get-product-size').click(
        function(e)
        {
            $('.site-popup.product-size-popup[data-size-map="' + $(this).data('sizeMap') + '"]').addClass('opened');

            $('body').addClass('fixed-body');
            $('.overflow-body').addClass('show-open-popup');
            e.preventDefault();
        }
    );

    /* открытие списка магазинов по клику на стрелочку */

    /*
    $('.product-page .stores .store .sore-title.store-offers').click(
        function()
        {

            if(!$(this).hasClass('stores-open'))
            {
                $(this).addClass('stores-open');
                $(this).find('.arrow .arrow-up').css('display', 'inline');
                $(this).find('.arrow .arrow-down').css('display', 'none');
            }
            else
            {
                $(this).removeClass('stores-open');
                $(this).find('.arrow .arrow-up').css('display', 'none');
                $(this).find('.arrow .arrow-down').css('display', 'inline');
            }

            $(this).parent().find('.stores-product-quantity').slideToggle();
        }
    )
    */

    $('.price-wr').each(function(){
        const prices = this.querySelectorAll('.price-block');
        if(prices.length >=3) {
            prices[0].classList.add('price-opt');
        }
    })

    // на странице товара переносим h1 в зависимости от разрешения экрана в блок над слайдером с изображениями товара или под него

    const h1Head = document.querySelector('.js-h1-head');
    const h1Row = document.querySelector('.js-h1-row');
    const mobileWrapper = document.querySelector('.js-h1-mobile-wrapper');

    const moveTitle = () => {
        if (h1Head && h1Row && mobileWrapper) {
            if (window.innerWidth <= 1024) {
                if (h1Head.parentElement !== mobileWrapper) {
                    mobileWrapper.prepend(h1Head);
                }
            } else if (h1Head.parentElement !== h1Row) {
                h1Row.prepend(h1Head);
            }
        }
    };

    moveTitle();
    window.addEventListener('resize', moveTitle);

});

/* accordion */

$(document).on('click', '.js-product-info-header', toggleAccordion);


function toggleAccordion(){
    $(this).toggleClass('open');
    // $('.js-accordion-body').not($(this).next()).slideUp(500);
    $(this).next('.product-info-tab__content').slideToggle(300);
}

//если таблица размеров открывается не по клику, а сразу выведена на страницу (на разрешении менее 1024)
// рассчитываем стоимость выбранных товаров при загрузке страницы

if ($(window).width() >= 1024 ) {
    document.addEventListener('DOMContentLoaded', function () {
        let $sizeTable = $('.product-page .product-size-block.in-stock-table');
        const tableRows = $sizeTable.find('.offer-wr');

        tableRows.each(function (index, element) {
            let $this = $(this);
            const $tableRow = $($this);
            const $amountInput = $tableRow.find('.amount-selector .amount-input');
            const inputValue = $amountInput.val();

            if(inputValue > 0) {
                $amountInput.attr('value', inputValue);
            }
        })

        // рассчитываем стоимость выбранных товаров. рассчитается не 0, если какой то размер уже был выбран ранее

        let productSizeBlock = $sizeTable;
        setTimeout(() => {
            calcPriceProduct(productSizeBlock);
        }, 600)

    });
}

// на мобильных устанавливаем скролл к активному элементу
document.addEventListener('DOMContentLoaded', function () {
    const targetElement = document.querySelector('.js-color-variants-block .color-variant-item.active');
    if (targetElement && window.innerWidth < 550) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
});
